export default "__VITE_ASSET__BheDQP8X__"